import React, { Component, Fragment } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from './telemetryService';
import { ChildrenProps } from '../utils/types';
import { App } from '../app';

// This Component provides telemetry with Azure App Insights
// NOTE: the package '@microsoft/applicationinsights-react-js' has a HOC withAITracking that requires this to be a Class Component rather than a Functional Component
class TelemetryProvider extends Component<ChildrenProps> {
    render(): JSX.Element {
        const { children } = this.props;
        return (
            <Fragment>
                {children}
            </Fragment>
        );
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        App?.telemetry?.postFault("Error", `Renderer: Unhandled exception encountered: ${error.stack}, ${errorInfo?.componentStack}`, error);
    }
}

export default withAITracking<any>(ai.reactPlugin, TelemetryProvider);
